import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../utils/api";
import { qk } from "../../lib/queryKeys";
import { useCompaniesStore } from "../../store/admin/companiesStore";
import { normalizeSmartTrackingConfig } from "./queries";
import type { SmartTrackingConfig, SmartTrackingConfigInput } from "./types";

export function useUpdateSmartTrackingConfig() {
  const queryClient = useQueryClient();
  const cid = useCompaniesStore((s) => s.companyId);

  return useMutation({
    mutationFn: (data: SmartTrackingConfigInput): Promise<SmartTrackingConfig> =>
      api
        .put("/smartTracking", data)
        .then((res) =>
          normalizeSmartTrackingConfig(res.data?.data?.data ?? res.data?.data),
        ),
    onSuccess: (config) => {
      queryClient.setQueryData(qk.smartTracking.config(cid), config);
    },
  });
}
